/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimPersonsResponseDto } from '../models/clm-claim-persons-response-dto';


/**
 * the ClaQueryReadPerson API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadPersonService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdPersonGet
   */
  static readonly ClaimClaimIdPersonGetPath = '/claim/{claimId}/person';

  /**
   * Get persons.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdPersonGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdPersonGet$Response(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimPersonsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadPersonService.ClaimClaimIdPersonGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimPersonsResponseDto>;
      })
    );
  }

  /**
   * Get persons.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdPersonGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdPersonGet(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClmClaimPersonsResponseDto> {

    return this.claimClaimIdPersonGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimPersonsResponseDto>) => r.body as ClmClaimPersonsResponseDto)
    );
  }

}
